import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
	header: {
		textAlign: 'center',
		padding: '8px 10px',
		fontSize: '26px',
		lineHeight: '39px',
		fontWeight: 700,
		color: '#595959',
	},
	title: {
		textAlign: 'center',
		fontSize: '14px',
		marginTop: '20px',
	},
};

class DuplicatesTemplate extends Component {
	render() {
		const {
			duplicates,
			isInCurrentOrganization,
			classes,
		} = this.props;

		const sortedDuplicates = duplicates.sort((a, b) => {
			return a.organizationName > b.organizationName
				? 1
				: a.organizationName < b.organizationName
					? -1
					: 0;
		})

		return (
			<div>
				<div className={classes.header}>
					Notice
				</div>
				{
					isInCurrentOrganization &&
					<div className={classes.title}>
						This phone number is not added as it is already present in the current Organization
					</div>
				}
				{
					!isInCurrentOrganization &&
					<div>
						<div className={classes.title}>
							Failed to add the following phone number(s) as the record(s) are already present in another Organization:
					</div>
						<ul>
							{sortedDuplicates.map(({ phoneNumber, organizationName }, index) => (
								<li key={index}>
									<b>{phoneNumber}</b> – {organizationName}
								</li>
							))}
						</ul>
					</div>
				}
			</div>
		);
	}
}

export default withStyles(styles)(DuplicatesTemplate);
